import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { loginApi } from "../../api/authApi";
import useAuth from "../../hooks/useAuth";
import useGoogleAuth from "../../hooks/useGoogleAuth";
import GoogleLoginButton from "../../components/auth/GoogleLoginButton";
import "../../styles/auth.css";

export default function LoginPage() {
    const navigate = useNavigate();
    const { login } = useAuth();

    const [form, setForm] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const {
        loginWithGoogle,
        loadingGoogle,
        googleError,
        setGoogleError,
    } = useGoogleAuth();



    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setGoogleError("");

        try {
            const resp = await loginApi(form);
            login(resp);
            navigate("/");
        } catch (err) {
            setError(err.message || "Credenciales inválidas");
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSuccess = useCallback(async (credential) => {
        setError("");
        setGoogleError("");

        try {
            await loginWithGoogle(credential);
            navigate("/");
        } catch (err) {
            console.error("Error login Google:", err);
        }
    }, [loginWithGoogle, navigate, setGoogleError]);

    const handleGoogleError = useCallback((message) => {
        setGoogleError(message || "No se pudo iniciar sesión con Google");
    }, [setGoogleError]);



    return (
        <div className="auth-page">
            <form className="auth-card" onSubmit={handleSubmit}>
                <h2>Iniciar sesión</h2>

                <input
                    name="email"
                    type="email"
                    placeholder="Correo"
                    value={form.email}
                    onChange={handleChange}
                />

                <input
                    name="password"
                    type="password"
                    placeholder="Contraseña"
                    value={form.password}
                    onChange={handleChange}
                />

                {error && <p className="auth-error">{error}</p>}

                <button type="submit" disabled={loading || loadingGoogle}>
                    {loading ? "Ingresando..." : "Ingresar"}
                </button>

                <div style={{ margin: "18px 0", textAlign: "center", color: "#777" }}>
                    o continúa con
                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <GoogleLoginButton
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleError}
                        disabled={loading || loadingGoogle}
                    />
                </div>

                {googleError && (
                    <p className="auth-error" style={{ marginTop: "12px" }}>
                        {googleError}
                    </p>
                )}

                {loadingGoogle && (
                    <p style={{ marginTop: "12px", textAlign: "center", color: "#666" }}>
                        Validando cuenta de Google...
                    </p>
                )}
            </form>
        </div>
    );
}